import './custom_script';

// const $ = window.jQuery;

// class WebpackTemplate {
//   /**
//    * Sets necessary variables for this class
//    * that are used throughout
//    */
//   constructor() {
//     this.name = 'WebpackTemplate';
//   }

//   /**
//    * Initializes all needed functions
//    */
// }

// $(document).ready(() => {
//   const wpt = new WebpackTemplate();
// });
